module.exports = __webpack_public_path__ + "img/logo-safest-icon.76a73f25.png";